import { SoftwareDownloadsState } from 'models/state/software-downloads';
import { combineReducers } from 'redux';
import { reducer as filesReducer } from './software-download-files';
import { reducer as softwareReducer } from './software-downloads';

export const softwareDownloadsReducer = 
combineReducers<SoftwareDownloadsState>({
    softwareDownloads: softwareReducer,
    softwareDownloadFiles: filesReducer,
});